// extracted by mini-css-extract-plugin
export default {"container":"cartTable_container__ko-fN","title":"cartTable_title__oYM6N"};